import { useSuspenseQuery } from "@tanstack/react-query";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";

import { Failed } from "@/common/components/info/info";
import { PropertiesList } from "@/common/components/properties-list/properties-list";
import { Spinner } from "@/common/components/spinner/spinner";

import { cropParametersQuery } from "../../api/crop-parameters.api";

type Props = {
  className?: string;
  cropId: string;
  traderId?: string;
};

const CropParameters = ({ className, cropId, traderId }: Props) => {
  const cropParameters = useSuspenseQuery(
    cropParametersQuery({
      cropId,
      traderId,
    }),
  );

  return (
    <div className={`border-t-can-silver-cloud border-t ${className}`}>
      <PropertiesList properties={cropParameters.data ?? []} />
    </div>
  );
};

const CropParametersTree = (props: Props) => (
  <ErrorBoundary fallbackRender={({ error }) => <Failed error={error} />}>
    <React.Suspense fallback={<Spinner />}>
      <CropParameters {...props} />
    </React.Suspense>
  </ErrorBoundary>
);

export { CropParametersTree as CropParameters };
